import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="container-editorial py-16 lg:py-24 max-w-3xl" data-testid="page-privacy">
      <span className="pill">Privacy</span>
      <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95]">Privacy Policy</h1>
      <p className="mt-4 text-viola/60 text-sm">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</p>

      <div className="mt-10 space-y-6 text-viola/85 leading-relaxed">
        <h2 className="font-display text-2xl mt-8">1. Titolare del trattamento</h2>
        <p>Il titolare del trattamento dei dati raccolti tramite questo sito è <strong>Dania (Dan) Piras</strong>, iscritto all'Albo degli Psicologi della Lombardia con n. 22141. Per qualsiasi richiesta puoi scrivere a <a href="mailto:dania.piras90@gmail.com" className="text-fucsia">dania.piras90@gmail.com</a> o <a href="mailto:danpiras.psy@gmail.com" className="text-fucsia">danpiras.psy@gmail.com</a>.</p>

        <h2 className="font-display text-2xl mt-8">2. Dati raccolti</h2>
        <p>Questo sito raccoglie i seguenti dati personali, solo quando l'utente li fornisce volontariamente:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Modulo contatti</strong>: nome, email, oggetto e testo del messaggio, motivo del contatto.</li>
          <li><strong>Newsletter</strong>: email e, opzionalmente, nome.</li>
          <li><strong>Dati di navigazione</strong>: log tecnici anonimizzati per fini statistici e di sicurezza (indirizzo IP, user-agent).</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">3. Finalità del trattamento</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Rispondere alle richieste inviate via modulo contatti.</li>
          <li>Inviare la newsletter (solo con consenso esplicito, revocabile in qualsiasi momento).</li>
          <li>Adempiere agli obblighi di legge e alla deontologia professionale.</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">4. Base giuridica</h2>
        <p>Il trattamento è basato su: <strong>consenso</strong> (art. 6.1.a GDPR) per la newsletter e i contatti volontari; <strong>obbligo di legge</strong> per gli adempimenti fiscali e deontologici; <strong>legittimo interesse</strong> per la sicurezza del sito.</p>

        <h2 className="font-display text-2xl mt-8">5. Comunicazione dei dati</h2>
        <p>I dati non vengono ceduti né venduti a terzi. Possono essere trattati da fornitori tecnici (hosting, invio email) sulla base di contratti di responsabile del trattamento ai sensi dell'art. 28 GDPR.</p>

        <h2 className="font-display text-2xl mt-8">6. Conservazione</h2>
        <p>I messaggi di contatto sono conservati per il tempo necessario a rispondere e per gli obblighi fiscali/legali. Le iscrizioni newsletter fino alla cancellazione richiesta dall'utente.</p>

        <h2 className="font-display text-2xl mt-8">7. Diritti dell'interessato</h2>
        <p>In qualsiasi momento puoi esercitare i diritti previsti dagli artt. 15–22 GDPR: <strong>accesso, rettifica, cancellazione, limitazione, opposizione, portabilità</strong>. Scrivi a <a href="mailto:dania.piras90@gmail.com" className="text-fucsia">dania.piras90@gmail.com</a> con oggetto «Diritti privacy». Hai inoltre diritto di proporre reclamo al Garante per la Protezione dei Dati Personali (<a href="https://www.gpdp.it" target="_blank" rel="noopener noreferrer" className="text-fucsia">gpdp.it</a>).</p>

        <h2 className="font-display text-2xl mt-8">8. Cookie</h2>
        <p>Per la gestione dei cookie consulta la <Link to="/cookie-policy" className="text-fucsia">Cookie Policy</Link>.</p>

        <p className="mt-10 text-sm text-viola/60">Questa policy può essere aggiornata: si consiglia di consultarla periodicamente.</p>
      </div>
    </div>
  );
}
